import { FreeGameModelBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist"

export class FreeGameModel extends FreeGameModelBehavior {



  protected cascadeSequence: string[] = ["checkForReveal", "showCascadingWin", "startNextLineToggle", "startNextCascade", "checkForReveal", "checkForWinAndSendClose"]
  private cascadeSequenceCounter: number = 0;
  /**
 * Overrided to add the cascade feature in animation sequenece
 * @param serverModel
 */
  constructor(serverModel: any) {
    super(serverModel);
    this.setAnimationSequence(["fgBigWin", "retriggeringAnimation", "doNextSpinInFreeGame"]);
  }



  public getCascadeSequence(): string[] {
    return this.cascadeSequence;
  }
  public setCascadeSequenceCounter(value: number) {
    this.cascadeSequenceCounter = value;
  }
  public updateCascadeSequenceCounter() {
    this.cascadeSequenceCounter++;
  }
  public getCascadeSequenceCounter(): number {
    return this.cascadeSequenceCounter;
  }

  public getIsBigWin(winAmount?: number): number {
    return 0;
  }
  public getIsFgBigWin(winAmount?: number): boolean {
    let win = this.getCurrentWinAmt();
    if (winAmount !== undefined) {
      win = winAmount;
    }
    const currBet = this.serverModel.getCurrentTotalBet();
    if (win > currBet * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
      return true;
    }
  }
  public getWinMeterTickUpDurationFg(evt?:number) {
    if (this.getIsTurboModeOn()) {
      return SlotConstantsBehavior.WINTICKUP_FG_4;
    }
    else  {
      return SlotConstantsBehavior.WINTICKUP_FG_1;
    }
  }
}
